import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-bottom: 20px;

  ::-webkit-scrollbar {
    width: 8px !important;
  }

  ::-webkit-scrollbar-track {
    background-color: ${theme.colors.blue800} !important;
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray800} !important;
    border-radius: 0 !important;
  }
`;

export const CardWrapper = styled.div`
  margin: 15px;
  border-radius: 20px;
  display: flex;
  flex-direction: row;
  padding: 20px;
  align-items: center;
  justify-content: space-between;
  background-color: ${theme.colors.darkBlue};
  gap: 20px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  padding: 12px 16px;
  border-radius: 100px;
  border: 1px solid ${theme.colors.gray800};
  background: ${theme.colors.blue900};
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  font-size: 14px;
  outline: none;

  &::placeholder {
    color: ${theme.colors.gray800};
  }

  &:focus {
    border-color: ${theme.colors.primary};
  }
`;

export const BackHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 15px 0;
`;

export const BackButton = styled.button`
  padding: 8px 16px;
  border-radius: 100px;
  border: 1px solid ${theme.colors.gray800};
  background: transparent;
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  font-size: 13px;
  cursor: pointer;

  &:hover {
    border-color: ${theme.colors.primary};
  }
`;

export const PageTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  margin: 0;
`;

export const SectionCard = styled.div`
  margin: 15px;
  border-radius: 20px;
  padding: 20px;
  background-color: ${theme.colors.darkBlue};
`;

export const InfoText = styled.p`
  font-size: 13px;
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  margin: 4px 0 16px 0;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: ${theme.font.poppins};
  font-size: 13px;
  margin-bottom: 12px;

  th, td {
    padding: 10px 12px;
    text-align: left;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }

  th {
    font-weight: 500;
    color: ${theme.colors.white};
    font-size: 11px;
    text-transform: uppercase;
  }

  td {
    color: ${theme.colors.white};
  }

  code {
    background: rgba(255, 255, 255, 0.08);
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 12px;
    color: ${theme.colors.lightBlue};
  }
`;

export const Badge = styled.span<{ $active: boolean }>`
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  background: ${(p) => (p.$active ? "rgba(76, 175, 80, 0.15)" : "rgba(255, 255, 255, 0.05)")};
  color: ${(p) => (p.$active ? "#4caf50" : theme.colors.gray800)};
`;

export const DefaultButton = styled.button<{ $isDefault: boolean }>`
  padding: 6px 14px;
  border-radius: 100px;
  border: 1px solid ${(p) => (p.$isDefault ? "#4caf50" : theme.colors.gray800)};
  background: ${(p) => (p.$isDefault ? "rgba(76, 175, 80, 0.15)" : "transparent")};
  color: ${(p) => (p.$isDefault ? "#4caf50" : theme.colors.white)};
  font-family: ${theme.font.poppins};
  font-size: 12px;
  cursor: ${(p) => (p.$isDefault ? "default" : "pointer")};
  white-space: nowrap;

  &:hover {
    border-color: ${(p) => (p.$isDefault ? "#4caf50" : theme.colors.primary)};
    color: ${(p) => (p.$isDefault ? "#4caf50" : theme.colors.primary)};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const NbsResultList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 15px;
`;

export const NbsResultItem = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  background: ${theme.colors.darkBlue};
  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};
  font-size: 13px;
  cursor: pointer;
  text-align: left;
  width: 100%;

  &:hover {
    border-color: ${theme.colors.primary};
  }

  code {
    background: rgba(255, 255, 255, 0.08);
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    color: ${theme.colors.lightBlue};
    white-space: nowrap;
  }

  span {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const LoadingText = styled.p`
  font-size: 13px;
  color: ${theme.colors.lightBlue};
  font-family: ${theme.font.poppins};
  text-align: center;
  padding: 20px;
`;

export const InfoBox = styled.div`
  background: rgba(12, 116, 136, 0.1);
  border: 1px solid rgba(12, 116, 136, 0.3);
  border-radius: 12px;
  padding: 12px 16px;
  margin: 0 15px 0;
  font-size: 12px;
  color: ${theme.colors.lightBlue};
  font-family: ${theme.font.poppins};
  line-height: 1.6;
`;
